import * as gameMenu from 'BASE/common/menu/menu.game';
import * as collection from 'BASE/common/collection/collection';
import { storage } from 'BASE/common/util/util.storage';
import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';
import { GameTag, getGameTag, getVRGameTag } from 'BASE/common/gameTag';
import gameCollectionStore from 'BASE/store/bet/bet.store.collection';
import GoExternalGameBase from '#BASE/components/externalGame/externalGame.go.component';
import slide_up_down from 'vue-slide-up-down';
import CollectionComponent from 'XC/components/collection/collection.component';

export default {
    name: 'LeftSideDrawLobby',
    mixins: [GoExternalGameBase,CollectionComponent],
    components: {
        slide_up_down,
    },
    data() {
        return {
            display:true,
            isShowLeftSideMenu: false,
            gameTag: GameTag,
            gameMenuClass: ["ssc", "vcssc", "elevenFive", "k3", "pk6", "pk10", "low"],
            gameMenus: {},            
            vrMenus: [],            
            vrPrefix: 'VR_',
            activedTab: '',
            isVrMenuActive: false,

            editCollectedGame: [],
            dialogName: 'favoriteEdit',
        };
    },
    computed: {
        gameDatas() {
            return this.$store.state.lottoinfo.data;
        },
        userName() {
            return this.$store.state.userinfo.userName;
        },
        LotteryMenu() {
            if (!this.gameMenus.homeLeft || this.gameMenus.homeLeft.Items.length <= 0)
                return [];

            let leftMenu = gameMenu.mergeInfo(this.gameMenus.homeLeft, [this.gameDatas]);
            if (Object.keys(leftMenu).length !== 0) {
                leftMenu.forEach(category => {
                    category.isActive = this.activedTab === category.Index;
                    category.Items.forEach(game => {
                        game.Tag = getGameTag(game.LotteryGameHotNewState);
                    });
                });
            }
            return leftMenu;
        },
        VrMenu() {
            if (Object.keys(this.vrMenus).length <= 0)
                return [];

            let vrItems = JSON.parse(JSON.stringify(this.vrMenus));
            for (let game of vrItems) {
                game.Tag = getVRGameTag(this.vrPrefix + game.GameCode);
            }
            return vrItems;
        },

        collectedGame() {
            return this.$store.getters[getterTypes.BET_GET_COLLECTIONS];
        },
        CollectedGames() {
            let result = [];
            if (Object.keys(this.gameDatas).length !== 0) {
                if (this.collectedGame.length > 0) {
                    // 玩家收藏的彩種
                    return this.mergeInfo(this.collectedGame, [this.gameDatas]);
                }
                else if (this.gameMenus.defaultCollection){
                    // 預設顯示的彩種
                    return this.mergeInfo(this.gameMenus.defaultCollection.gameIds, [this.gameDatas]);
                }
            }
            return result;
        },
    },
    watch:{
        "$route.name": function (val, oldVal) {
            let _this = this;
            _this.display = true;
            if(val == "DrawHistory" || val == "Register" || val == "Timeout" || val == "IPRestricted" || val == "ErrorMsg" || val == "LinkFailure" || val == "Offline"){
                _this.display = false;
            }
        }
    },
    methods: {
        switchLeftSideMenu() {
            this.isShowLeftSideMenu = !this.isShowLeftSideMenu;
            storage.local.set(storage.keys.LEFT_MENU_STATE, this.isShowLeftSideMenu);
        },
        clickTab(newTab) {
            if(this.isShowLeftSideMenu) {
                this.showTab(newTab);
            }
        },
        mouseOverTab(newTab) {
            if(!this.isShowLeftSideMenu) {
                this.showTab(newTab);
            }
        },
        mouseleaveTab() {
            if(!this.isShowLeftSideMenu) {
                this.activedTab = '';
            }            
        },
        showTab(newTab) {
            if (newTab === this.activedTab) {
                this.activedTab = '';
                return;
            }
            this.activedTab = newTab;
        },

        mergeInfo(collected, objs) {
            let res = [];
            let _this = this;
            if (!collected || objs.some(o => !o)) {
                return res;
            }

            for (let _gameId of collected) {
                let infos = {};
                infos = objs.map(o => o[_gameId]);
                if (infos.every(i => i)) {
                    res.push(Object.assign({ Id: _gameId }, ...infos));
                }
            }
            return res;
        },

        showFavoriteEdit(){  
            this.editCollectedGame = this.collectedGame.slice();
            let _dialog = this.$dialog.get(this.dialogName);
            _dialog.show();
        },

        chooseCollect(val) { //選擇收藏
            let valStr = val.toString();
            let _checkCollect = this.editCollectedGame;
            if (_checkCollect.indexOf(valStr) > -1) {
                //已選須取消
                let index = _checkCollect.findIndex(e => e == valStr);
                if (index >= 0) {
                    _checkCollect.splice(index, 1);
                }
            } else {
                if (_checkCollect.length >= this.maxCollect) this.$dialog.warning('已添加彩种已满。'); //自定义彩种已满提示
                else _checkCollect.push(valStr);
            }
        },

        clearCollect() {
            this.editCollectedGame = [];
        },

        async saveCollected() { //儲存快捷
            if (this.collectedGame.length !== this.editCollectedGame.length ||
                !this.collectedGame.every((id, index) => id === this.editCollectedGame[index])) {
                
                this.$store.dispatch(actionTypes.BET_SET_COLLECTIONS, { userName : this.userName, gameIdArr : this.editCollectedGame, collectionType : this.collectionType });
            }
            let _dialog = this.$dialog.get(this.dialogName);
            _dialog.$emit('close');
        },
    },    
    async mounted() {
        let state = storage.local.get(storage.keys.LEFT_MENU_STATE);
        if(state == null){
            state = true;
            storage.local.set(storage.keys.LEFT_MENU_STATE, state);
        }
        this.isShowLeftSideMenu = state;

        let _this = this;
        const gameMenus = gameMenu.get();
        const vrMenus = this.getVRLottery();   // 取得VR彩票
        const collectedGame = this.$store.dispatch(actionTypes.BET_GET_COLLECTIONS, { userName: _this.userName, collectionType: _this.collectionType});

        gameMenus.then(r => _this.gameMenus = r);
        vrMenus.then(r => _this.vrMenus = r);

        await Promise.all([gameMenus, vrMenus, collectedGame]);
    },
    beforeCreate() {
        if(this.$store.state.gameCollection) {
            this.$store.unregisterModule('gameCollection');
        }
        this.$store.registerModule('gameCollection', new gameCollectionStore());
    },
    beforeDestroy() {
        this.$store.unregisterModule('gameCollection');
    },
}